import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, computed, inject, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Option } from '@dxc-technology/halstack-angular';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonService, setLocalStorageItem } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
// import { HalApiCaller } from '@dxc-technology/halstack-client';
// import { OAuthService } from 'angular-oauth2-oidc';
import { HttpClient } from '@angular/common/http';
import { MessagesService } from 'src/app/services/messages.service';

import { EmittedValue } from '@dxc-technology/halstack-angular/lib/dxc-select/dxc-select.types';
import { CustomSelectComponent } from '../../dxc-custom/custom-select/custom-select.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CustomSelectComponent, TranslatePipe],
})
export class HeaderComponent implements OnInit, AfterViewChecked {
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);
  private readonly route = inject(ActivatedRoute);
  private readonly commonService = inject(CommonService);
  private readonly messagesService = inject(MessagesService);
  private readonly http = inject(HttpClient);
  private readonly cdr = inject(ChangeDetectorRef);

  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  readonly toggleSidebarForMe = output();
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  ON_CUSTOMIDP = environment.ON_CUSTOMIDP;
  customLogoutURL = environment.ON_CUSTOMIDP_Auth.logoutURL;
  loginURL = environment.ON_CUSTOMIDP_Auth.LoginUrl;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  lang: any = {};
  role: any = {};
  lob: any = {};
  isLoading: boolean = false;
  isMenuOpen: boolean = true;
  isMenuClose: boolean = false;
  header: any;
  detailUser: any;
  profileUser: any;
  //Profile Login/Logout
  Profile = [
    {
      value: 1,
      label: 'My Profile',
    },
    {
      value: 2,
      label: 'Log out',
    },
  ];
  //download dropdown
  DownloadList = [];
  //dropdown for Languages
  optionsLanguages: Option[] = [];
  optionsLOBs: any;
  optionsRoles: any = [];
  currentLanguage: any;
  isLanguageDropdownOpen: boolean = false;
  isDragging: boolean = false;
  startX: number = 0;
  scrollLeft: number = 0;
  dragThreshold: number = 5;
  /* WRITTEN BY Claude Code */
  isLanguageBottomSheetOpen: boolean = false;
  /* END Claude Code */

  readonly homeBtn = output();
  constructor() {
    this.initModuleSerivce();
  }
  initModuleSerivce() {
    this.header = this.commonService.getHeaders();
  }

  private readonly breakpointObserver = inject(BreakpointObserver);
  isMobile: boolean = false;

  async ngOnInit(): Promise<void> {
    this.breakpointObserver.observe(['(max-width: 1024px)']).subscribe(result => {
      this.isMobile = result.matches;
    });

    if (!localStorage.getItem('country')) {
      localStorage.setItem('country', '');
    }
    const lang = localStorage.getItem('language') || environment.language;
    this.onChangeLanguage({ value: lang, error: undefined });
    this.commonService.setlanguageChange(this.currentLanguage);
    window.addEventListener('localStorageChanged', (event: any) => {
      const key = event.key ?? event.detail?.key;
      const newValue = event.newValue ?? event.detail?.newValue;
      if (key === 'language' && newValue && newValue !== this.currentLanguage) {
        this.onChangeLanguage({ value: newValue, error: undefined });
        this.commonService.setlanguageChange(this.currentLanguage);
      }
    });

    if (this.PROFILE === this.ON_CUSTOMIDP) {
      window.addEventListener('customidp-auth-complete', () => {
        this.refreshUserData();
      });
    }

    setTimeout(() => {
      this.initParam();
    }, 3000);
  }

  refreshUserData(): void {
    this.getDetailUser();
    this.cdr.detectChanges();
  }

  ngAfterViewChecked(): void {
    this.getAllLanguage();
    this.cdr.detectChanges();
  }

  getAllLanguage() {
    let allLanguage = this.commonService.allConfigDropdownList?.language_Setup;
    if (allLanguage?.length != 0) {
      allLanguage?.forEach((language) => {
        language.value = language.value.toLowerCase();
      });
    }
    this.optionsLanguages = allLanguage;
  }

  async getDetailUser() {
    try {
      let userName = localStorage.getItem('userName');
      let res = await this.commonService.getDetailUserName(userName);
      localStorage.setItem('selectedUserId', res.userModelId);
      localStorage.setItem('profileId', res.profile[0].profileUuid);
    } catch (error) {}
  }

  toggleSidebar(event) {
    this.toggleSidebarForMe.emit();
    if (this.isMobile) return; // Logic below is for desktop arrows

    if (event == 'menu') {
      this.isMenuOpen = false;
      this.isMenuClose = true;
    } else {
      this.isMenuOpen = true;
      this.isMenuClose = false;
    }
  }

  async initParam() {
    if (localStorage.getItem('personaDropDown') != null) {
      this.optionsRoles = JSON.parse(localStorage.getItem('personaDropDown') || '');
      this.optionsLOBs = JSON.parse(localStorage.getItem('lobDropDown') || '');
      /* let personaDescription = this.optionsRoles.find(
        (persona) => persona.value == sessionStorage.getItem('selected_role')
      );
      localStorage.setItem('personaDescription', personaDescription?.label); */
    } else {
      setTimeout(async () => {
        if (localStorage.getItem('personaDropDown') != null) {
          this.optionsRoles = JSON.parse(localStorage.getItem('personaDropDown') || '');
          this.optionsLOBs = JSON.parse(localStorage.getItem('lobDropDown') || '');
          /* let personaDescription = this.optionsRoles.find(
            (persona) => persona.value == sessionStorage.getItem('selected_role')
          );
          localStorage.setItem('personaDescription', personaDescription?.label); */
        }
      }, 1500);
    }
    if (localStorage.getItem('userName') != null) {
      let profileUser = await this.getUserInformation(localStorage.getItem('userName'));
      this.getDropdownPersona(profileUser);
      if (this.optionsRoles.length == 1) {
        this.role.select = this.optionsRoles[0].value;
        sessionStorage.setItem('selected_role', this.role.select);
      }
    } else {
      setTimeout(async () => {
        if (localStorage.getItem('userName') != null) {
          let profileUser = await this.getUserInformation(localStorage.getItem('userName'));
          this.getDropdownPersona(profileUser);
          if (this.optionsRoles.length == 1) {
            this.role.select = this.optionsRoles[0].value;
            sessionStorage.setItem('selected_role', this.role.select);
          }
        }
      }, 1500);
    }
    // let personaDescription = this.optionsRoles.find((persona: any) => persona.value == sessionStorage.getItem('selected_role'));
    // localStorage.setItem('personaDescription', personaDescription?.label);
  }

  redirectHome(event: any) {
    localStorage.setItem('isExpanMemberDetails', 'N');
    localStorage.setItem('selectedSideNavigation', 'proposal');
    if (event) {
      this.router.navigate([`/proposal/proposal-dashboard`], { relativeTo: this.route });
      setTimeout(() => {
        this.homeBtn.emit();
      }, 10);
    }
  }
  //condition for Profile Login/Logout
  onChangeMenu(event: any) {
    if (event == '1') {
    } else if (event == '2') {
      // OIDC enviroment (OKTA,o Auth0, etc....)
      if (this.PROFILE === this.ON_PREMISES) {
        this.doLogout(this.ON_PREMISES);
      }
      // Congito environment
      else if (this.PROFILE === this.ON_CLOUD) {
        this.doLogout(this.ON_CLOUD);
      }
      // CAS environment
      else if (this.PROFILE === this.ON_PREMISES_CAS) {
        this.doLogout(this.ON_PREMISES_CAS);
      }
      //CUSTOMIDP enviroment
      else if (this.PROFILE === this.ON_CUSTOMIDP) {
        this.doLogout(this.ON_CUSTOMIDP);
      }
    }
  }

  // checkUrl(): boolean {
  //   if (this.route.snapshot['_routerState'].url.search('home') == 1) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  async getUserInformation(userName: any) {
    // // let detailUser = await this.getDetailUserName(userName);
    // this.getDetailUserName(userName).subscribe(val => {
    //
    //   this.detailUser = val;
    // })
    // //sessionStorage.setItem('selected_role', detailUser.profile[0].roleType);
    // localStorage.setItem('selectedUserId', this.detailUser.userModelId);
    // localStorage.setItem('fullNameUser', this.detailUser.userName);
    // /* let profileUser = await this.getProfileUser(
    //   localStorage.getItem('userName'),
    //   detailUser.userModelId,
    //   detailUser.profile[0].profileUuid
    // ); */

    // this.getActiveProfileUser(localStorage.getItem('userName')).subscribe(val => {
    //   this.profileUser = val;
    // })

    // sessionStorage.setItem('selected_role', this.profileUser.roleType);
    // localStorage.setItem('clientNumber', this.profileUser.clientId);
    // localStorage.setItem('profileId', this.profileUser.uuid);
    // this.lob.select = this.profileUser.lob;
    // this.role.select = sessionStorage.getItem('selected_role');
    // return this.detailUser.profile;
    return '';
  }
  getDetailUserName(userName: any) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    this.header = this.commonService.getHeaders();
    // let data = await HalApiCaller.get({
    //   headers: { ...this.header, username: userName, persona, clientnumber },
    //   url:
    //     environment.API_COMMON_USERROLE_SERVER_URL +
    //     `/userdata/${userName}/getUserProfile?list=userInfo,roles`,
    // });
    // return data.body;

    return this.http.get(environment.API_COMMON_USERROLE_SERVER_URL + `/userdata/${userName}/getUserProfile?list=userInfo,roles`);
  }
  async getProfileUser(userName: any, userId: any, profileId: any) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    // let data = await HalApiCaller.get({
    //   headers: { ...this.header, username: userName, persona, clientnumber },
    //   url:
    //     environment.API_COMMON_USERROLE_SERVER_URL +
    //     `/users/${userId}/profiles/${profileId}`,
    // });
    // return data.body;

    return this.http.get(environment.API_COMMON_USERROLE_SERVER_URL + `/users/${userId}/profiles/${profileId}`);
  }
  getActiveProfileUser(userName: any) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    // let data = await HalApiCaller.get({
    //   headers: { ...this.header, username: userName, persona, clientnumber },
    //   url:
    //     environment.API_COMMON_USERROLE_SERVER_URL +
    //     `/${userName}/userProfile/active`,
    // });
    // return data.body;

    return this.http.get(environment.API_COMMON_USERROLE_SERVER_URL + `/${userName}/userProfile/active`);
  }
  getDropdownPersona(profileUser: any) {
    for (let j = this.optionsRoles.length - 1; j > -1; j--) {
      let findItem = false;
      for (let i = profileUser.length - 1; i > -1; i--) {
        if (profileUser[i].roleType == this.optionsRoles[j].value) {
          findItem = true;
          break;
        }
      }
      if (findItem == false) this.optionsRoles.splice(j, 1);
    }
  }
  //conditions for selecting lob
  onChangeLOB(event: any, lob: any) {
    lob.select = event.value;
    localStorage.setItem('selected_lob', lob.select);
    let lobDescription = this.optionsLOBs.find((lob: any) => lob.value == localStorage.getItem('selected_lob'));
    localStorage.setItem('lobDescription', lobDescription.label);
  }
  //conditions for selecting roles
  onChangeRole(event: any, role: any) {
    role.select = event.value;
    sessionStorage.setItem('selected_role', role.select);
    let personaDescription = this.optionsRoles.find((persona: any) => persona.value == sessionStorage.getItem('selected_role'));
    localStorage.setItem('personaDescription', personaDescription.label);
    this.commonService.rolesChange.emit();
  }

  //conditions for selecting languages
  onChangeLanguage(lang: EmittedValue) {
    const value = lang.value as string;
    this.commonService.setTriggerlangChange(value);

    this.lang.select = value;
    this.currentLanguage = value;
    this.translate.setDefaultLang(value);
    this.translate.use(value);
    this.commonService.currentLang.set(value);
    this.commonService.getTranslateValue.emit();
    if (localStorage.getItem('language') !== value) {
      setLocalStorageItem('language', value);
    }
    this.commonService.setlanguageChange(value);
  }

  toggleLanguageDropdown() {
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
  }

  closeLanguageDropdown() {
    this.isLanguageDropdownOpen = false;
  }

  getCurrentLanguageLabel(): string {
    const currentLang = this.optionsLanguages?.find((lang) => lang.value === this.lang.select);
    return currentLang?.label ?? 'English';
  }

  getSortedLanguages(): Option[] {
    if (!this.optionsLanguages) return [];

    const currentLang = this.optionsLanguages.find((lang) => lang.value === this.lang.select);
    const otherLangs = this.optionsLanguages.filter((lang) => lang.value !== this.lang.select);

    return currentLang ? [currentLang, ...otherLangs] : this.optionsLanguages;
  }

  selectLanguage(language: Option) {
    if (language?.value) {
      this.onChangeLanguage({ value: language.value, error: undefined });
      this.closeLanguageDropdown();
      this.closeLanguageBottomSheet();
    }
  }

  /* WRITTEN BY Claude Code */
  openLanguageBottomSheet() {
    this.isLanguageBottomSheetOpen = true;
  }

  closeLanguageBottomSheet() {
    this.isLanguageBottomSheetOpen = false;
  }

  getCurrentLanguageCode(): string {
    return this.lang.select?.toUpperCase() || 'EN';
  }
  /* END Claude Code */

  onLanguageContainerWheel(event: WheelEvent) {
    event.preventDefault();
    const container = event.currentTarget as HTMLElement;
    const scrollAmount = 60;

    if (event.deltaY > 0) {
      container.scrollLeft += scrollAmount;
    } else {
      container.scrollLeft -= scrollAmount;
    }
  }

  onLanguageContainerMouseDown(event: MouseEvent) {
    const container = event.currentTarget as HTMLElement;
    this.startX = event.pageX - container.offsetLeft;
    this.scrollLeft = container.scrollLeft;
  }

  onLanguageContainerMouseMove(event: MouseEvent) {
    if (this.startX === 0) return;

    const container = event.currentTarget as HTMLElement;
    const x = event.pageX - container.offsetLeft;
    const distance = Math.abs(x - this.startX);

    if (distance > this.dragThreshold && !this.isDragging) {
      this.isDragging = true;
      event.preventDefault();
    }

    if (this.isDragging) {
      event.preventDefault();
      const walk = (x - this.startX) * 2;
      container.scrollLeft = this.scrollLeft - walk;
    }
  }

  onLanguageContainerMouseUp() {
    this.isDragging = false;
    this.startX = 0;
  }

  onLanguageContainerMouseLeave() {
    this.isDragging = false;
    this.startX = 0;
  }
  doLogout(value: any) {
    let logOutURL = environment.logOutURL;
    sessionStorage.removeItem('isLogin');
    localStorage.removeItem('access_token');
    localStorage.removeItem('userName');

    if (value === 'customIDP') {
      sessionStorage.clear();
      localStorage.clear();
      this.deleteCookie('username');
      this.deleteCookie('access_token');
      this.deleteCookie('channel');

      window.open(this.loginURL, '_self');
      return;
    }
    window.open(logOutURL, '_self');
  }

  private deleteCookie(name: string) {
    try {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      const domain = window.location.hostname;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`;
    } catch (error) {
      console.error('Failed to delete cookie:', error);
    }
  }

  //conditions for display header
  isShowHeaderForSignUp() {
    return localStorage.getItem('isSignUp') == 'N' ? true : false;
  }
}
